


















import Vue from 'vue'
import { Alert, TextLink } from '@raksul/raksul-common-ui'
export default Vue.extend({
  name: 'IeDeprecatedAlert',
  components: {
    Alert,
    TextLink
  }
})
